import {  MESSAGE_SET_UNREAD_DATA } from '../action-types';
import { GetUnreadMessageCount } from '@/api/message-center';


// 设置未读消息完整数据
export const setUnreadData = (data) => {
    return {
        type: MESSAGE_SET_UNREAD_DATA,
        data
    };
};

// 获取未读消息数
export const fetchUnreadCount = () => {
    return async (dispatch) => {
        try {
            const response = await GetUnreadMessageCount();
            if (response) {
                // 存储完整的未读消息数据
                dispatch(setUnreadData(response));
            }
        } catch (error) {
            dispatch(setUnreadData(null));
        }
    };
}; 